import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { KJUR } from 'jsrsasign';
import { windowService } from './window.service';
import { BackendService } from "./backend.service";
import { SvcServices } from "./svc.service";

declare var threatmetrix: any;
@Injectable()
export class ProfilingService {
    blackBoxId: any;
    devicePrint: any;
    head: any;
    script: any;
    sessionID: any;
    tmId: any;
    window: any;
    hash: any;
    globalData: any;

    constructor(private _window: windowService, private _svcService: SvcServices, private _backend: BackendService) {
        this.window = _window.nativeWindow;
    }

    getCyotaData() {
        if (this.blackBoxId && this.blackBoxId !== undefined){
            return this.blackBoxId;
        }
        else {
            try{
            var bb_data = this.window.ioGetBlackbox();
            this.blackBoxId = bb_data.blackbox;
            //this._backend.blackBox = this.blackBoxId;
            return this.blackBoxId;
            }catch(e){
                console.warn('Issues in get Blackbox');
                return "";
            }
        }
        
    }

    getInetData() {
        if(this.devicePrint && this.devicePrint !== undefined){
            return this.devicePrint;
        }
        else {
            try{
            var fPrint_old = this.window.add_deviceprint();//variable to store Device Finger print information post calling Fingerprint method of fp_AA JS
            this.devicePrint = this.window.encode_deviceprint();
            //this._backend.devicePrint = this.devicePrint;
            return this.devicePrint;
            }catch(e){
                console.warn('Issues in get deviceprint');
            }
        }
    }

    get_new_tmx_sessionid() {
        try {
            this.globalData = this._svcService.getGlobalData();
            let tmxOrgId;
            if (this.globalData.tmxOrgId !== null && this.globalData.tmxOrgId !== undefined) {
                tmxOrgId = this.globalData.tmxOrgId;
            } else {
                tmxOrgId = this._svcService.getTmxOrgId();
            } 
            this.globalData = this._svcService.getGlobalData();
            //if(USCRS.getTMXEnabledByPartner()=='true'){
            // this.head = document.getElementsByTagName("head").item(0);
            // this.script = document.createElement("script");
            // this.script.setAttribute("type", "text/javascript");
            this.sessionID = this.generateSessionID();
            // this.script.setAttribute("id", this.sessionID);
            // this.script.setAttribute("src",
            //     "https://content22.citibankonline.com/tags.js?org_id=" + tmxOrgId + "&session_id="
            //     + this.sessionID + "&page_id=1&allow_reprofile=1");
            // this.head.appendChild(this.script);
            threatmetrix.profile('h.online-metrix.net', tmxOrgId, this.sessionID);
            // if (this.window.addEventListener) {
            //     this.window.addEventListener("profiling-complete",
            //         this.tmx_profiling_complete(this.sessionID), false);
            // }
            this.tmId = this.sessionID;
            this._backend.tmId = this.tmId;
            return this.tmId;
        } catch (err) {
            console.warn("Error in profiling-  tmx");
        }

    }

    tmx_profiling_complete(session_id) {
        try {
            if (this.sessionID != null) {
                var profilingTag = document.getElementById(this.sessionID);
                profilingTag.parentNode.removeChild(profilingTag);
                //document.getElementById(sessionID).remove();
                this.window
                    .removeEventListener("profiling-complete",
                    this.tmx_profiling_complete);
            }
        } catch (err) {
            console.warn("Error in profiling-  tmx");
        }

    }

    generateSessionID() {
        const date = new Date();
        //currently placing CRSDESKTOP as default channelId until we hear otherwise
        var strToHash = date.toString() + this.getuuid() + "WEB_BROWSER";
        this.hash = KJUR.crypto.Util.sha256(strToHash).toString();
        return this.hash;
    }
    getuuid() {
        const uuid = KJUR.crypto.Util.getRandomHexOfNbytes(16);
        return uuid;
    }
}
